import React from "react";
import { Link } from "react-router-dom";
import { HeartIcon } from "../ui";

export default function Footer() {
  return (
    <>
      <footer className="bg-black border-t border-white/5 px-[5%] py-10 lg:py-[60px] grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 text-center md:text-left">
        <div>
          <a
            href="/"
            className="flex items-center justify-center md:justify-start gap-2.5 text-white font-bold text-[15px] md:text-[17px] no-underline mb-3.5"
          >
            <div className="w-9 h-9 rounded-[10px]  bg-black border border-white/10 flex items-center justify-center flex-shrink-0">
              <HeartIcon className="w-[18px] h-[18px] text-white" />
            </div>
            Max &amp; Sherry
          </a>
          <p className="text-[12px] md:text-[13px] text-white/30 leading-relaxed max-w-[260px] mx-auto md:mx-0">
            Real Connections for Malawi. Built for real connections — on values,
            interests, and vibe.
          </p>
        </div>
        <div>
          <h4 className="text-[11px] font-semibold uppercase tracking-[1.5px] text-white/25 mb-[18px]">
            App
          </h4>
          {["How it works", "Features", "Pricing", "Download"].map((l) => (
            <Link
              key={l}
              to={`/#${l.toLowerCase().replace(/\s+/g, "-")}`}
              className="block text-sm text-white/40 no-underline mb-2.5 hover:text-white/80 transition-colors duration-200"
            >
              {l}
            </Link>
          ))}
        </div>
        <div>
          <h4 className="text-[11px] font-semibold uppercase tracking-[1.5px] text-white/25 mb-[18px]">
            Legal
          </h4>
          <Link
            to="/privacy"
            className="block text-sm text-white/40 no-underline mb-2.5 hover:text-white/80 transition-colors duration-200"
          >
            Privacy policy
          </Link>
          <Link
            to="/terms"
            className="block text-sm text-white/40 no-underline mb-2.5 hover:text-white/80 transition-colors duration-200"
          >
            Terms of use
          </Link>
          <Link
            to="/safety"
            className="block text-sm text-white/40 no-underline mb-2.5 hover:text-white/80 transition-colors duration-200"
          >
            Safety centre
          </Link>
          <Link
            to="/contact"
            className="block text-sm text-white/40 no-underline mb-2.5 hover:text-white/80 transition-colors duration-200"
          >
            Contact us
          </Link>
          <Link
            to="/support"
            className="block text-sm text-white/40 no-underline mb-2.5 hover:text-white/80 transition-colors duration-200"
          >
            Support
          </Link>
          <Link
            to="/delete-account"
            className="block text-sm text-white/40 no-underline mb-2.5 hover:text-white/80 transition-colors duration-200"
          >
            Delete account
          </Link>
        </div>
      </footer>
      <div className="bg-black border-t border-white/5 px-[5%] py-6 flex flex-col items-center text-center md:flex-row md:justify-between md:text-left gap-1.5 md:gap-2">
        <p className="text-[11px] md:text-[12px] text-white/20">
          © 2026 Max &amp; Sherry ConnectPlus. All rights reserved.
        </p>
        <p className="text-[11px] md:text-[12px] text-white/20">
          Made with ♥ in Malawi
        </p>
      </div>
    </>
  );
}
